import React, { createContext, useState, useContext, ReactNode } from 'react';

interface BannerVisibility {
  hideMainMarketBanner: boolean;
  hideClubPassButton: boolean;
  hideMarketHeaderLink: boolean;
  hideAll: boolean;
}

interface BannerContextProps extends BannerVisibility {
  setBannerVisibility: (bannerName: string, isVisible: boolean) => void;
}

const BannerContext = createContext<BannerContextProps>({
  hideMainMarketBanner: false,
  hideClubPassButton: false,
  hideMarketHeaderLink: false,
  hideAll: false,
  setBannerVisibility: () => {},
});

export const useMarketBannersContext = () => useContext(BannerContext);

interface MarketBannersProviderProps {
  children: ReactNode;
}

export const MarketBannersProvider: React.FC<MarketBannersProviderProps> = ({
  children,
}) => {
  const [bannersVisibility, setBannersVisibility] = useState({
    hideMainMarketBanner: false,
    hideClubPassButton: false,
    hideMarketHeaderLink: false,
    hideAll: false,
  });

  const setBannerVisibility = (bannerName: string, isVisible: boolean) => {
    setBannersVisibility(prevVisibility => ({
      ...prevVisibility,
      [bannerName]: isVisible,
    }));
  };

  return (
    <BannerContext.Provider value={{ ...bannersVisibility, setBannerVisibility }}>
      {children}
    </BannerContext.Provider>
  );
};
